import { hideNotification, notify } from '@ps-int/ps-components/src/notifications/slice';
import { delay, put, take } from 'typed-redux-saga';

import { goloomSdk } from '../../../../../shared/features/goloom-sdk';
import { NOTIFICATIONS_MAP } from '../../../../../shared/features/notifications/ps-notifications';
import { emitterEventChannelFactory } from '../../../../../shared/helpers/emitterEventChannelFactory';
import { NotificationId } from '../../../types';

const UNMUTE_NOTIFICATION_LIFE_TIME = 5000;

/**
 * Показ нотифайки
 * Если пользователь находится в другом окне, показываем, дожидаемся пока вернется и скрываем через
 * UNMUTE_NOTIFICATION_LIFE_TIME
 */
export function* localVadChangedSaga(value: boolean) {
    if (value && !goloomSdk.session?.audioStatus) {
        yield* put(notify(NOTIFICATIONS_MAP[NotificationId.PLEASE_UNMUTE]()));
        // если пользователь в другой вкладке
        if (document.hidden) {
            const channel = emitterEventChannelFactory(window, 'focus');
            try {
                yield* take(channel);
            } finally {
                channel.close();
            }
        }

        yield* delay(UNMUTE_NOTIFICATION_LIFE_TIME);
        yield* put(hideNotification(NotificationId.PLEASE_UNMUTE));
    }
}
